"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAffiliateRewardsPointsChangeReason = void 0;
var AvenAffiliateRewardsPointsChangeReason;
(function (AvenAffiliateRewardsPointsChangeReason) {
    AvenAffiliateRewardsPointsChangeReason["affiliateCommissionEarned"] = "affiliateCommissionEarned";
    AvenAffiliateRewardsPointsChangeReason["avenAdvisorRedemption"] = "avenAdvisorRedemption";
    AvenAffiliateRewardsPointsChangeReason["avenAdvisorReversal"] = "avenAdvisorReversal";
})(AvenAffiliateRewardsPointsChangeReason || (exports.AvenAffiliateRewardsPointsChangeReason = AvenAffiliateRewardsPointsChangeReason = {}));
